import { render, staticRenderFns } from "./NamespaceRow.vue?vue&type=template&id=3a4b9166&scoped=true&"
import script from "./NamespaceRow.vue?vue&type=script&lang=js&"
export * from "./NamespaceRow.vue?vue&type=script&lang=js&"
import style0 from "./NamespaceRow.vue?vue&type=style&index=0&id=3a4b9166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b9166",
  null
  
)

export default component.exports